import { CheckOutlineIcon } from '@ikyucom/design-system-icons-react'
import type { FC, PropsWithChildren } from 'react'
import ReservationCompleteHeader from '~/components/header/sd/ReservationCompleteHeader'
import { StackableFusuma } from '~/components/modal/StackableFusuma'
import { useReserveOverlay } from '~/navigation'
import { css, sva } from '~/styled-system/css'
import {
  CancelPolicy,
  ConfirmButton,
  Conversion,
  Detail,
  EmailSendNotification,
  RequestReservation,
  SuccessMessage,
} from '../../shared/reservationSuccess'

const styles = sva({
  slots: ['heading', 'icon', 'content'],
  base: {
    heading: {
      display: 'flex',
      justifyContent: 'center',
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 'full',
      bgColor: 'background',
      h: '[64px]',
      w: '[64px]',
    },
    content: {
      spaceY: '3',
      borderRadius: 'md',
      bgColor: 'white',
      p: '5',
      textAlign: 'center',
    },
  },
})

export function ReservationSuccessFusuma() {
  const [context, willBeUnmounted] = useReserveOverlay('NEW_RESERVE_SUCCESS')
  if (context === undefined) {
    return null
  }
  const classes = styles()
  return (
    <StackableFusuma willBeUnmounted={willBeUnmounted}>
      <ReservationSuccess>
        <ReservationCompleteHeader />
        <div className={classes.heading}>
          <div className={classes.icon}>
            <CheckOutlineIcon className={css({ color: 'tertiary' })} width={36} height={36} />
          </div>
        </div>
        <SuccessMessage />
        <div className={classes.content}>
          <Detail />
          <RequestReservation />
          <ConfirmButton />
          <EmailSendNotification />
        </div>
        <CancelPolicy />
        <Footer />
        <Conversion />
      </ReservationSuccess>
    </StackableFusuma>
  )
}

const ReservationSuccess: FC<PropsWithChildren> =
  import.meta.env.VITE_MODE === 'ppg' ? PpgReservationSuccess : IkyuReservationSuccess

function IkyuReservationSuccess({ children }: PropsWithChildren) {
  return (
    <div
      className={css({
        height: '[100dvh]',
        spaceY: '5',
        overflowY: 'scroll',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        px: '5',
      })}
      style={{ backgroundImage: 'url(https://restaurant.img-ikyu.com/rsImg/top/award.jpg)' }}
    >
      {children}
    </div>
  )
}

function PpgReservationSuccess({ children }: PropsWithChildren) {
  return (
    <div
      className={css({
        height: '[100dvh]',
        spaceY: '5',
        overflowY: 'scroll',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        px: '5',
      })}
      style={{
        backgroundImage:
          'url(https://restaurant.img-ikyu.com/paypaygourmet/img/bg_reservation.jpg)',
      }}
    >
      {children}
    </div>
  )
}

const Footer: FC = import.meta.env.VITE_MODE === 'ppg' ? PpgFooter : IkyuFooter

function IkyuFooter() {
  return (
    <div className={css({ p: '5', textAlign: 'center', fontSize: 'xs', color: 'white' })}>
      Copyright Ikyu Corporation. All Rights Reserved.
    </div>
  )
}

function PpgFooter() {
  return (
    <div className={css({ p: '5', textAlign: 'center', fontSize: 'xs', color: 'white' })}>
      © LY Corporation
    </div>
  )
}
